import { apiFetch } from '../utils/api';

/**
 * Fetches categories belonging to a specific section name.
 * Utilizing the backend-assisted query parameter filtering (Option B) for scalability.
 * @param {string} sectionName - The section name (e.g. "National Articles")
 * @returns {Promise<Array>} List of category documents matching the section
 */
export const getCategoriesBySection = async (sectionName) => {
  const url = sectionName 
    ? `/api/categories?section=${encodeURIComponent(sectionName)}`
    : '/api/categories';
    
  const response = await apiFetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch categories: ${response.statusText}`);
  }
  return response.json();
};
